export default __webpack_public_path__ + "static/media/pete.930a0233.png";